import { render } from "./WidgetSelectPaginator.vue?vue&type=template&id=34509e2d"
import script from "./WidgetSelectPaginator.vue?vue&type=script&lang=js"
export * from "./WidgetSelectPaginator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__